export default {
  data() {
    return {
      /* toolbarSettings: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ["bold", "italic", "underline", "strike"],
        [{ header: 1 }, { header: 2 }],
        [{ script: "sub" }, { script: "super" }],
        [{ direction: "rtl" }],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ align: "" }, { align: "center" }, { align: "right" }, { align: "justify" }],
        ["link", "clean"]
      ], */
      cdn_base_url: "https://media.dpauls.com/drive-server/"
    };
  },
  created() {
    const height = document.documentElement.clientHeight;
    document.documentElement.style.setProperty("--vh", `${height}px`);
  }
};
